module.exports = __webpack_public_path__ + "img/kk_mart.eb183ae6.png";